import BannerStatic, { BannerType } from 'elem/compCommon/BannerStatic';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { SceneEmail } from '@elem/compCommon/SceneEmail';
import EcoImg from 'eco-design/base/eco-img';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('outdoorrecreation');
    const IS_NA = ['us', 'ca'].includes(locale);
    // UK属于英规
    const EU_SITES: string[] = ['eu', 'de', 'fr', 'it', 'es', 'cis', 'za'];
    // 本地化图片
    const LOCAL_SITES: string[] = ['au', 'kr'];
    const data: BannerType = {
        src: `/responsive/picture/outdoor-recreation/1${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        srcDesktop: `/responsive/picture/outdoor-recreation/1_1366${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        srcPad: `/responsive/picture/outdoor-recreation/1_768${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        srcMobile: `/responsive/picture/outdoor-recreation/1_768${EU_SITES.includes(locale) ? '_eu' : LOCAL_SITES?.includes(locale) ? `_${locale}` : ''}.jpg`,
        alt: t('secA_title'),
        title: t('secA_title'),
        desc: t('secA_desc'),
        btnText: t('secA_btn'),
        link: '#outdoor-recreation-C',
        theme: 'black',
    };
    if (locale === 'us' || locale === 'ca') {
        // data.src = 'https://websiteoss.ecoflow.com/upload/image/1747800086627/kv_na.jpg';
        data.src = 'https://websiteoss.ecoflow.com/upload/image/1747821766082/na_pc.jpg';
        data.srcDesktop = 'https://websiteoss.ecoflow.com/upload/image/1747821766082/na_pc.jpg';
        data.srcPad = 'https://websiteoss.ecoflow.com/upload/image/1748242396958/kv_na_pad.jpg';
        data.srcMobile = 'https://websiteoss.ecoflow.com/upload/image/1748242399966/kv_na_h5.jpg';
        data.theme = 'black';
    }
    if (locale === 'au') {
        data.src = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716539768426/kv_au_1366.png';
        data.srcDesktop = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716539768426/kv_au_1366.png';
        data.srcPad = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716540084221/kv_au_768.png';
        data.srcMobile = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1716540084221/kv_au_768.png';
        data.theme = '';
    }
    if (locale === 'za') {
        data.src = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717578505675/kv_za_1366.png';
        data.srcDesktop = 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717578505675/kv_za_1366.png';
    }
    return (
        <div className={`outdoor-recreation-A ${css['outdoor-recreation-A']}`}>
            {IS_NA ? (
                <>
                    <EcoImg
                        pc={'https://websiteoss.ecoflow.com/upload/image/1747821766082/na_pc.jpg'}
                        pad={'https://websiteoss.ecoflow.com/upload/image/1748242396958/kv_na_pad.jpg'}
                        h5={'https://websiteoss.ecoflow.com/upload/image/1748242399966/kv_na_h5.jpg'}
                        alt={t('secA_title')}
                        aria-label={t('secA_title')}
                    />
                    <div className="info">
                        <p className="title">{t('secA_title')}</p>
                        <SceneEmail theme="black" type="OUTDOOR_RECRATION" title={t('secA_title')} />
                    </div>
                </>
            ) : (
                <BannerStatic {...data} />
            )}
        </div>
    );
}
